export function isIdentifiable(
  obj: any
): obj is Record<string, unknown> & { id: number | string } {
  if (!obj || typeof obj !== 'object') return false;
  return Object.keys(obj).includes('id');
}
